// Lightweight in-session navigation history so the premium mobile back
// button can return to the *actual* page the user came from, not a
// hard-coded index. sessionStorage survives PWA/SPA refreshes.
const PREV_KEY = 'av_prev_path';

export const setPreviousPath = (path) => {
  try {
    window.sessionStorage.setItem(PREV_KEY, path || '/');
  } catch (err) {
    // Storage may be unavailable (private mode) — back falls back to history.
  }
};

export const getPreviousPath = () => {
  try {
    return window.sessionStorage.getItem(PREV_KEY);
  } catch (err) {
    return null;
  }
};

export const clearPreviousPath = () => {
  try {
    window.sessionStorage.removeItem(PREV_KEY);
  } catch (err) {
    // ignore
  }
};